import { supabase } from "@/integrations/supabase/client";

// Autumn configuration
export const autumnConfig = {
  secretKey: import.meta.env.VITE_AUTUMN_SECRET_KEY,
  backendUrl: "https://rdbsxmojtwktfbuhvmoi.supabase.co/functions/v1/autumn",
};

// Export Autumn components and hooks
export { AutumnProvider, useCustomer } from "autumn-js/react"; 